<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label" translate>{{ getTitle() }}</h3>
    </div>
  </div>
  <form class="form form-group-seperator-dashed" [formGroup]="messageForm">
    <div class="navi-hover scroll card-body" [perfectScrollbar]="{ wheelPropagation: false }">
      <div class="card-body-progress">
        <mat-spinner [diameter]="20"></mat-spinner>
      </div>
      <kt-alert *ngIf="hasFormErrors" type="warn" [showCloseButton]="false" [duration]="10000">
        {{ 'AUTH.VALIDATION.INVALID_OR_REQUIRED' | translate }}
      </kt-alert>
      <kt-alert
        *ngIf="hasSubmissionErrors && !hasFormErrors"
        type="warn"
        [duration]="30000"
        [showCloseButton]="false"
      >
        <ul>
          <li *ngFor="let msg of submissionErrorObj">{{ msg.error | translate }}</li>
        </ul>
      </kt-alert>
      <div class="form-group">
        <div class="row">
          <div class="col kt-margin-bottom-20-mobile">
            <kt-general-autocomplete
              [appearance]="'fill'"
              [label]="'MESSAGE.INPUT.RECEIVER' | translate"
              [loadItemsFunction]="searchUsers"
              [optionFormatter]="displayFn"
              [valueFormatter]="displayFn"
              [required]="true"
              [readOnly]="false"
              [control]="myControl"
              [change]="selectedReceiver.bind(this)"
              [dataPath]="'data'"
              [placeholder]="'Receiver selection'"
              [chipList]="true"
              [objects]="myControl.value"
              [formatNewObjectFn]="formatNewReceiverFn"
              #receiverAutocomplete
            ></kt-general-autocomplete>
          </div>
        </div>
        <div class="row">
          <div class="col kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'MESSAGE.INPUT.TEXT' | translate }}</mat-label>
              <textarea matInput formControlName="body" rows="7"></textarea>
            </mat-form-field>
          </div>
        </div>
        <ng-template ngxPermissionsOnly="accessToTagCommunication">
          <div class="row">
            <div class="col col-sm-12">
              <kt-tags
                [autocompleteEntity]="'COMMUNICATION'"
                [controlObject]="messageForm.get('tags')"
                [appearance]="'fill'"
                [canAddComponent]="true"
              ></kt-tags>
            </div>
          </div>
        </ng-template>
        <div class="row">
          <div class="col kt-margin-bottom-20-mobile">
            <input
              formControlName="file"
              type="file"
              name="attachments"
              (change)="onFileChange($event)"
              multiple
            />
          </div>
        </div>
        <kt-custom-progress-bar
          *ngIf="showFileLoader | async"
          [requests]="uploadRequests"
          [totalFileSize]="totalFileSize"
          (callback)="callbackOnFileLoad()"
        ></kt-custom-progress-bar>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button
            (click)="close()"
            type="button"
            mat-raised-button
            cdkFocusInitial
            matTooltip="Cancel"
          >
            <span translate="GLOBAL.CANCEL">Cancel</span></button
          >&nbsp;
          <button
            type="button"
            mat-raised-button
            color="primary"
            [disabled]="clicked"
            (click)="onSubmit()"
            matTooltip="Send"
          >
            <span translate="AUTH.INPUT.SEND">Send</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
